"use strict";

exports.__esModule = true;
exports.default = void 0;
var _actions = _interopRequireDefault(require("./actions"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = {
  Id: {
    displayName: 'ID',
    type: 'String',
    guarded: true,
    sortable: true,
    filterable: true
  },
  DisplayName: {
    displayName: 'Name',
    type: 'String',
    rules: [],
    value: '',
    sortable: true,
    filterable: true
  },
  Code: {
    displayName: 'Code',
    type: 'String',
    rules: [],
    value: '',
    sortable: true,
    filterable: true
  },
  Published: {
    displayName: 'Published',
    type: 'Bool',
    rules: [],
    value: false,
    sortable: true,
    filterable: true
  },
  LanguageImage: {
    displayName: 'Picture',
    type: 'RelationPicture',
    rules: [],
    value: '',
    format: 'base64',
    entity: {
      local: 'Language',
      foreign: 'LanguageImage'
    },
    add: _actions.default.addPicture,
    update: _actions.default.updatePicture,
    drop: _actions.default.dropPicture,
    sortable: true,
    filterable: false
  }
};
module.exports = exports.default;